import React, { createContext, useContext } from 'react';

const SsrRequestContext = createContext({});

export function SsrRequestProvider({ children, req = null }) {
	return <SsrRequestContext.Provider value={req}>{children}</SsrRequestContext.Provider>;
}

export function useSsrRequest() {
	return useContext(SsrRequestContext);
}

